




import { Component, Vue } from 'vue-property-decorator';
import { ConstantsModuleMapper } from '@/store/modules/constants';

const Mappers = Vue.extend({
  computed: {
    ...ConstantsModuleMapper.mapGetters(['isLoaded', 'copyright']),
  },
});
@Component
export default class FooterCopyrightComponent extends Mappers {
  get formattedYear() {
    let rawText = this.$t(`${this.copyright}`, this.$i18n.locale) as string;
    const date = new Date();
    rawText = rawText.replace(/{0,number,#}/g, `${date.getFullYear()}`);
    return rawText;
  }
}
